import loadModuleOnElement from "../../utils/loadModuleOnElement";

const loader = () => import("./module");
const selector = ".rebellt-item.has_voting";

export default function assemblerUpDownVotingLoader(context) {
    loadModuleOnElement(selector, loader, context);
    return context;
}
